import { useEffect } from 'react';

export default function Analytics() {
  const gaId = process.env.REACT_APP_GA_ID;
  useEffect(() => {
    if (!gaId) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', gaId);
  }, [gaId]);
  return null;
}
